var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCtaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35112 14.1488C8.35131 14.619 7.97013 15.0002 7.50016 15C7.27314 15 7.05783 14.9104 6.89825 14.7508C6.73868 14.5912 6.64906 14.3759 6.64907 14.149L6.64919 8.35105L0.851186 8.35102C0.624211 8.35102 0.408907 8.26141 0.249339 8.10184C0.0898666 7.94236 0.000188989 7.72714 7.13396e-08 7.50015C-0.000190394 7.0301 0.381029 6.64892 0.850967 6.64911L6.64907 6.64914L6.64904 0.851182C6.64885 0.381032 7.03003 -0.000190422 7.5 7.13601e-08C7.97025 -1.00316e-05 8.3511 0.380802 8.35109 0.851023L8.35112 6.6491L14.149 6.64898C14.6192 6.64897 15 7.0298 15 7.49986C15.0002 7.97002 14.619 8.35124 14.149 8.35105L8.35109 8.35118L8.35112 14.1488Z",
    fill: "#00C48C",
    stroke: "#00C48C",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2246:118798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35112 14.1488C8.35131 14.619 7.97013 15.0002 7.50016 15C7.27314 15 7.05783 14.9104 6.89825 14.7508C6.73868 14.5912 6.64906 14.3759 6.64907 14.149L6.64919 8.35105L0.851186 8.35102C0.624211 8.35102 0.408907 8.26141 0.249339 8.10184C0.0898666 7.94236 0.000188989 7.72714 7.13396e-08 7.50015C-0.000190394 7.0301 0.381029 6.64892 0.850967 6.64911L6.64907 6.64914L6.64904 0.851182C6.64885 0.381032 7.03003 -0.000190422 7.5 7.13601e-08C7.97025 -1.00316e-05 8.3511 0.380802 8.35109 0.851023L8.35112 6.6491L14.149 6.64898C14.6192 6.64897 15 7.0298 15 7.49986C15.0002 7.97002 14.619 8.35124 14.149 8.35105L8.35109 8.35118L8.35112 14.1488Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2246:118798)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCtaGreen);
export default __webpack_public_path__ + "static/media/PlusCTAGreen.4cf707dc.svg";
export { ForwardRef as ReactComponent };